import React from "react";
import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { MdPersonSearch } from "react-icons/md";
import Patient from "../shared/Patient";
import * as API from "../api";
import useDebounce from "./useDebounce";

export default function PatientSearch({ taskHandler }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);

  const [isSearching, setIsSearching] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  useEffect(async () => {
    if (debouncedSearchTerm) {
      setIsSearching(true);
      const response = await API.getPatientByName(debouncedSearchTerm);
      setResults(response.patients);
    } else {
      setResults([]);
      setIsSearching(false);
    }
  }, [debouncedSearchTerm]);

  const renderMapPatients = (patients) =>
    patients.map((p) => (
      <div key={p.id} className={"patient-row"} onClick={() => taskHandler(p)}>
        <Patient patient={{ ...p }} />
      </div>
    ));

  return (
    <div>
      <br />
      <Card.Title as="h4">{"Select patient"}</Card.Title>
      <p className="lead2">
        <MdPersonSearch className="patient-search-icon" />
        Search patients by name{" "}
      </p>
      <input
        className="default"
        placeholder="Search Patients"
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="pt20-pb10">
        {isSearching && (
          <b>
            Found {results.length} patient(s) matching search <br />
          </b>
        )}
        <div className="patient-search">{!!results.length > 0 && renderMapPatients(results)}</div>{" "}
      </div>
    </div>
  );
}
